import React from "react";
import { withRouter, Link } from "react-router-dom";
import { Wrapper } from "@networkraildigitalfactory/components";
import PageTitle from "../PageTitle/PageTitle";
import TabTable from "../TabTable/TabTable";
import PerformanceContent from "../MyPerformanceContent/MyPerformanceContent";
import styles from "./MyPerformance.module.css";

const MyPerformace = (props) => {
  const { isLineManagerView, performancesFilters, setPerformancesFilters } = props;
  const paragraph = (
    <>
      <p>You can prep for all interim and End of Year (EOY) reviews here.</p>
      <p>
        Once your review has taken place, you will be able to see your line manager’s comments for
        each review.
      </p>
      <p>
        Haven’t had an End of Year review and need to close out last years objectives? Click{" "}
        <Link style={{ color: "#37519D", textDecoration: "underline" }} to="/close-objectives">
          here
        </Link>
      </p>
    </>
  );
  const tabsList = [
    {
      name: `${!isLineManagerView ? "My " : ""}Performance`,
      data: (
        <div id={`${!isLineManagerView ? "my" : ""}performancePanel`} className={styles.tabPanel}>
          <PerformanceContent
            isLineManagerView={false}
            performancesFilters={performancesFilters}
            setPerformancesFilters={setPerformancesFilters}
            employeeEmail={props.user.email}
          />
        </div>
      ),
    },
  ];

  return (
    <Wrapper maxWidth={1375} align="center">
      <PageTitle titleHeader="My Performance" titleParagraph={paragraph} hideButton />
      <div className={styles.tab_container}>
        <TabTable style={{ fontSize: "18px" }} tabs={tabsList} defaultActive="myperformance" />
      </div>
    </Wrapper>
  );
};

export default withRouter(MyPerformace);
